import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const Container = styled.div({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

export const ImageContainer = styled.div<{ selected?: boolean; height: number; width: number }>(
    ({ theme, selected, height, width }) => ({
        overflow: "hidden",
        height: `${height}px`,
        width: `${width}px`,
        borderRadius: theme.cornerRadius.small,
        border: selected ? "3px solid #F34F01" : "1px solid rgba(2, 6, 12, 0.15)",
        boxShadow: selected
            ? "0px 4px 8px 0px rgba(27, 30, 36, 0.08)"
            : "0px 4px var(--blur-low, 8px) 0px var(--color-slate-alphas-8, rgba(2, 6, 12, 0.08))",
    })
);

export const Title = styled(Text)<{ gridItemWidth: number }>(({ theme, gridItemWidth }) => ({
    WebkitFontSmoothing: "auto",
    textAlign: "center",
    marginTop: theme.spacing.xSmall,
    wordWrap: "break-word",
    whiteSpace: "pre-line",
    width: gridItemWidth,
}));

export const Separator = styled.div(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    height: "1px",
    marginBottom: `${theme.spacing.medium}`,
    margin: "0 auto",
    width: "90%",
}));

export const StickContainer = styled.div<{ isSticky: boolean; isVisible: boolean }>(
    ({ theme, isSticky, isVisible }) => ({
        position: "relative",
        width: "100%",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(-10px)",
        pointerEvents: isVisible ? "auto" : "none",

        ...(isSticky && {
            position: "absolute",
            top: "56px",
            background: theme.colors[theme.colorMode].background_Primary,
            borderRadius: `0 0 ${theme.spacing.xLarge} ${theme.spacing.xLarge}`,
            boxShadow: "0px 28px 28px 0px rgba(2, 6, 12, 0.1)",
            zIndex: 10,
        }),

        ...(!isSticky && {
            overflow: "hidden",
            transition: "opacity 0.2s ease, transform 0.2s ease, height 0.3s ease",
        }),
    })
);

export const GridWrapper = styled.div<{ height?: number }>(({ height }) => ({
    transition: height !== undefined ? "height 0.3s ease" : "none",
    height: height !== undefined ? `${height}px` : "auto",
    overflow: "hidden",
    willChange: "height",
}));
